<template>
  <div>
    <!-- Questions table -->
    <div class="card questions mt-3"
         qid="questions-section"
         id="update_question"
    >
      <div class="card-body" style="overflow-x:auto;">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="questions-table-title">
                {{ $t('maintenance.questions.label') }}
              </h5>
            </div>

          </div>
          <div class="col-sm-6 text-right">

            <button class="btn btn-success ml-3 pl-3 pr-3"
                    @click="showCreateRRModal()"
                    qid="question-create-button"
                    v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create_button') }}
            </button>
          </div>
        </div>

        <table class="table table-responsive-md table-drag-and-drop">
          <thead>
            <tr>
              <th scope="col" width="50">

              </th>
              <th scope="col" width="400">
                {{ $t('maintenance.questions.table.name') }}
              </th>
              <th scope="col" width="150">
                {{ $t('maintenance.questions.table.type') }}
              </th>
              <th scope="col" width="200">
                {{ $t('maintenance.questions.table.allow_description') }}
              </th>
              <th scope="col">
                {{ $t('maintenance.questions.table.allow_attachment') }}
              </th>
              <th width="130"></th>
            </tr>
          </thead>
          <draggable v-model="tableItems" :force-fallback="true" @start="drag=true" @end="drag=false" tag="tbody" @change="postOrder">
            <tr v-for="object in tableItems" :key="object.id">
              <td style="cursor: move;" class="text-center" width="50">
                <font-awesome-icon icon="arrows-alt" />
              </td>
              <td width="400">
                <span v-if="object && object.name">
                  {{ object.name }}
                </span>
              </td>
              <td width="150">
                <span v-if="object.response_type">
                  <span class="badge badge-info">
                    {{ $t('maintenance.questions.type.' + $options.filters.slugify(object.response_type)) }}
                  </span>
                </span>
              </td>
              <td width="200">
                <span v-if="object.add_description">
                  {{ $t('maintenance.questions.type.' + $options.filters.slugify(object.add_description)) }}
                </span>
              </td>
              <td>
                <span v-if="object.add_attachments">
                  {{ $t('maintenance.questions.type.' + $options.filters.slugify(object.add_attachments)) }}
                </span>
              </td>
              <td class="text-right">
                <span class="btn btn-edit"
                      qid="edit-v-modal"
                      v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                      @click="showEditRRModal(object)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <button class="btn btn-delete"
                        qid="delete-question-modal"
                        v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                        @click="showRRConfirmDeleteModal(object)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </td>
            </tr>
            <tr v-if="!loading && !tableItems.length" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </draggable>
        </table>
        <br>

      </div>
    </div>


    <!-- Delete retention rule modal template -->
    <b-modal ref="delete-question" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-question-title">
          {{ $t('maintenance.questions.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.description') }}
        <span v-if="itemToDelete && itemToDelete.name">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.questions.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideRRConfirmDeleteModal"
                  qid="delete-question-cancel-button"
        >
          {{ $t('maintenance.questions.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteRR(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-question-submit-button"
        >
          {{ $t('maintenance.questions.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add new question -->
    <b-modal ref="add-question" hide-footer @hide="hideCreateRRModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('maintenance.questions.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('maintenance.questions.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-v-form-name"
              type="text"
              v-model="form.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-v-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-rr-attachments-label">
              {{ $t('maintenance.retention_rules.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
            <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
            <label class="btn btn-secondary cursor-pointer" qid="create-rr-attachments-button">
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file-rr"
                     @change="onFileChange"
                     @click="resetFile"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('attachments.upload_button') }}
              </span>
            </label>
          </b-form-group>
          <b-form-group>
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>
            <p v-for="(link, index) in form.links">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeLinkItem(index)"
                    qid="create-tp-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
            </p>
            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="handleLink"
                  qid="create-tp-add-link"
            >
              + {{ $t('system.add_link') }}
            </span>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Select'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span>{{ option }}</span>
            </p>
            <div class="input-group">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Select'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value != 'Select'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>
          <b-form-group>
            <label qid="create-s-tags-label">
              {{ $t('maintenance.questions.create.positive_responses_label') }}
            </label>
            <multiselect
                v-model="positiveAnswers"
                :options="allAnswersCopy"
                :multiple="true"
                :taggable="false"
                @select="handleAvailableAnswers"
                @remove="expandAvailableAnswers"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.questions.create.positive_responses_placeholder')"
                qid="create-do-tags-select"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="responseType && responseType.value == 'Select'">
            <label qid="create-s-tags-label">
              {{ $t('maintenance.questions.create.negative_responses_label') }}
            </label>
            <multiselect
                v-model="negativeAnswers"
                :options="allAnswersCopy"
                :multiple="true"
                @select="handleAvailableAnswers"
                @remove="expandAvailableAnswers"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.questions.create.negative_responses_placeholder')"
                qid="create-do-tags-select"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.add_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addAttachments"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateRRModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('maintenance.questions.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.questions.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit question -->
    <b-modal ref="edit-question" hide-footer @hide="hideEditRRModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('maintenance.questions.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editFormSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('maintenance.questions.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-v-form-name"
              type="text"
              v-model="form.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-v-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-rr-attachments-label">
              {{ $t('maintenance.retention_rules.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </label>
            <br>
            <p v-for="file in selectedQuestion.media">
              <span class="float-right text-muted cursor-pointer"
                    @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-p-media-item">
                {{ file.file_name }}
              </a>
            </p>
            <label class="btn btn-secondary cursor-pointer"
                   qid="create-p-file-button"
            >
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file"
                     @change="onFileChangeEdit"
                     @click="resetFileEdit"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('system.upload') }}
              </span>
            </label>
          </b-form-group>
          <b-form-group>
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>
            <div v-if="selectedQuestion.links">
              <p v-for="link in selectedQuestion.links" >
                <span class="float-right text-muted cursor-pointer"
                      @click="openDeleteLinkModal(link)"
                      qid="view-p-remove-link"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-p-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
            <div v-if="showInput">
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer"
                  @click="showInput = true"
                  qid="add-another-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
            </span>
          </b-form-group>

          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
                @select="handleType"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Select'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span>{{ option }}</span>
            </p>
            <div class="input-group">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showOptionInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showOptionInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showOptionInput = true"
                  v-if="!showOptionInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value == 'Select'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value != 'Select'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>
          <b-form-group>
            <label qid="create-s-tags-label">
              {{ $t('maintenance.questions.create.positive_responses_label') }}
            </label>
            <multiselect
                v-model="positiveAnswers"
                :options="allAnswersCopy"
                :multiple="true"
                :taggable="false"
                @select="handleAvailableAnswers"
                @remove="expandAvailableAnswers"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.questions.create.positive_responses_placeholder')"
                qid="create-do-tags-select"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="responseType && responseType.value == 'Select'">
            <label qid="create-s-tags-label">
              {{ $t('maintenance.questions.create.negative_responses_label') }}
            </label>
            <multiselect
                v-model="negativeAnswers"
                :options="allAnswersCopy"
                :multiple="true"
                :taggable="false"
                @select="handleAvailableAnswers"
                @remove="expandAvailableAnswers"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.questions.create.negative_responses_placeholder')"
                qid="create-do-tags-select"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.add_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addAttachments"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditRRModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('maintenance.questions.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.questions.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import draggable from 'vuedraggable'
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';

  export default {
    name: 'QuestionsTable',
    data: function() {
      return {
        form: {
          name: '',
          description: '',
          links: []
        },
        responseType: [],
        addDescription: [],
        addAttachments: [],

        error: '',
        tableItems: [],
        loading: true,
        itemToDelete: {},
        buttonDisabled: false,

        responseTypes: [
          { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' },
          { name: this.$t('maintenance.questions.type.select'), value: 'Select' }
        ],
        allowTypes: [
          { name: this.$t('maintenance.questions.type.no'), value: 'No' },
          { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
          { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        allAnswers: [],
        allAnswersCopy: [],
        selectedQuestion: [],
        showInput: true,
        showOptionInput: true,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      tasks: {
        type: Array
      },
      guides: {
        type: Array
      }
    },
    components: {
      Avatar,
      draggable,
      ConfirmRemoveAttachment
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },
      object: function (value) {
        this.assessment = value
      },
      selectedOptions: function (value) {
        let self = this
        this.allAnswers = value
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        _.forEach(this.positiveAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
        _.forEach(this.negativeAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
      }
    },
    methods: {
      handleType(value) {
        this.positiveAnswers = []
        this.negativeAnswers = []
        if (value && value.value == 'Select') {
          this.allAnswers = this.selectedOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.allAnswers = this.yesNoOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      handleOption(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOption !== '') {
          this.selectedOptions.push(this.inputOption)
          // Reset link input form
          this.inputOption = ''
        }
        this.showOptionInput = false;
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadQuestion();
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadQuestion();
      },
      handleEditLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'))
          self.loadQuestion()
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChangeEdit(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'))
            self.error = ''
            self.loadQuestion()
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      removeOptionItem(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
        let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

        this.selectedOptions.splice(index, 1);

        if (!this.selectedOptions.length) {
          this.showOptionInput = true;
        }

        if (positiveIndex != -1) {
          this.positiveAnswers.splice(positiveIndex, 1)
        }
        if (negativeIndex != -1) {
          this.negativeAnswers.splice(negativeIndex, 1)
        }
      },
      handleAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index != -1) {
          this.allAnswersCopy.splice(index, 1)
        }
      },
      expandAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index == -1) {
          this.allAnswersCopy.push(answer)
        }
      },
      showCreateRRModal() {
        this.$refs['add-question'].show()
      },
      hideCreateRRModal() {
        this.error = ''
        this.selectedOptions = []
        this.inputOption = ''
        this.positiveAnswers = []
        this.negativeAnswers = []
        this.allAnswers = []
        this.responseType = []
        this.addDescription = []
        this.addAttachments = []
        this.selectedFiles = []
        this.form.links = []
        this.inputLink = ''
        this.showInput = true
        this.showOptionInput = true
        this.form.name = ''
        this.form.description = ''
        this.$refs['add-question'].hide()
      },
      showEditRRModal(object) {
        let self = this;
        this.selectedQuestion = object;

        this.responseType = []
        if (object.response_type) {
          this.responseType = _.find(this.responseTypes, function(item) {
            return item.value === object.response_type;
          });

          if (this.selectedQuestion.response_type == 'Select') {
            this.allAnswers = this.selectedOptions
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          } else {
            this.allAnswers = this.yesNoOptions
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          }
        }

        this.addDescription = []
        if (object.add_description) {
          this.addDescription = _.find(this.allowTypes, function(item) {
            return item.value === object.add_description;
          });
        }

        this.addAttachments = []
        if (object.add_attachments) {
          this.addAttachments = _.find(this.allowTypes, function(item) {
            return item.value === object.add_attachments;
          });
        }

        this.positiveAnswers = []
        if (this.selectedQuestion.response_type_positive_response) {
          let array = JSON.parse(this.selectedQuestion.response_type_positive_response)
          this.positiveAnswers.push(...array)
        }

        this.negativeAnswers = []
        if (this.selectedQuestion.response_type_negative_response) {
          let array = JSON.parse(this.selectedQuestion.response_type_negative_response)
          this.negativeAnswers.push(...array)
        }

        if (this.selectedQuestion.response_type == 'Select') {
          this.selectedOptions = []
          if (this.selectedQuestion.response_type_options) {
            let array = JSON.parse(this.selectedQuestion.response_type_options)
            this.selectedOptions.push(...array)
          }
        }

        this.form.slug = object.slug;
        this.form.name = object.name;
        this.form.description = object.description;
        this.$refs['edit-question'].show()
      },
      hideEditRRModal() {
        this.error = ''
        this.selectedOptions = []
        this.inputOption = ''
        this.positiveAnswers = []
        this.negativeAnswers = []
        this.allAnswers = []
        this.responseType = []
        this.addDescription = []
        this.addAttachments = []
        this.showInput = true
        this.showOptionInput = true
        this.inputLink = ''
        this.form.name = ''
        this.form.description = ''
        this.$refs['edit-question'].hide()
      },
      postOrder() {
        let self = this;
        let order = []
        _.forEach(this.tableItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });
        })
        piincHttp.post('questions/order', {
          assessment_id: this.assessment.id,
          order: order
        }).then(function(response) {
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      showRRConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-question'].show()
      },
      hideRRConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-question'].hide()
      },
      confirmDeleteRR(object) {
        let self = this;
        piincHttp.delete('questions/' + object.slug).then(function() {
          self.hideRRConfirmDeleteModal();
          self.loadQuestions();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.questions.delete.success'))
        }, function() {});
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        let files = document.querySelector('#file-rr');
        let sizeError = false;

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.handleLink()

        formData.append("assessment_id", this.assessment.id);
        formData.append("name", this.form.name);
        formData.append("description", this.form.description);

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        if (this.responseType && this.responseType.value) {
          formData.append("response_type", this.responseType.value);
        }

        if (this.addDescription && this.addDescription.value) {
          formData.append("add_description", this.addDescription.value);
        }

        if (this.addAttachments && this.addAttachments.value) {
          formData.append("add_attachments", this.addAttachments.value);
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          formData.append("response_type_options", JSON.stringify(this.selectedOptions))
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          formData.append("response_type_positive_response", JSON.stringify(this.positiveAnswers))
        }

        if (this.negativeAnswers && this.negativeAnswers.length) {
          formData.append("response_type_negative_response", JSON.stringify(this.negativeAnswers))
        }

        if (sizeError) {
          this.error = this.$t('system.file_size')
          this.buttonDisabled = false;
        } else {
          this.buttonDisabled = true;

          if (this.responseType && this.responseType.value && this.addDescription && this.addDescription.value && this.addAttachments && this.addAttachments.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) {
            piincHttp.post('questions', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('maintenance.questions.create.success'))
              self.hideCreateRRModal();
              self.loadQuestions();
              self.$emit('updated');
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            this.error = '';
            self.buttonDisabled = false;
            if (!this.responseType || (this.responseType && !this.responseType.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message')
            }
            if (!this.addDescription || (this.addDescription && !this.addDescription.value)) {
              this.error += this.$t('maintenance.questions.create.add_description_error_message')
            }
            if (!this.addAttachments || (this.addAttachments && !this.addAttachments.value)) {
              this.error += this.$t('maintenance.questions.create.add_attachments_error_message')
            }
            if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
              this.error += this.$t('maintenance.questions.create.selected_options_error_message')
            }
          }
        }

      },
      resetFile() {
        let imagefile = document.querySelector('#file-rr');
        imagefile.value = '';
      },
      resetFileEdit() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-rr');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      editFormSubmit(evt) {
        this.buttonDisabled = true;

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        let form = {};

        form.name = this.form.name
        form.description = this.form.description

        if (this.responseType && this.responseType.value) {
          form.response_type = this.responseType.value
        }

        if (this.addDescription && this.addDescription.value) {
          form.add_description = this.addDescription.value
        }

        if (this.addAttachments && this.addAttachments.value) {
          form.add_attachments = this.addAttachments.value
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          form.response_type_options = JSON.stringify(this.selectedOptions)
        } else {
          form.response_type_options = '[]'
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          form.response_type_positive_response = JSON.stringify(this.positiveAnswers)
        } else {
          form.response_type_positive_response = '[]'
        }

        if (this.negativeAnswers && this.negativeAnswers.length) {
          form.response_type_negative_response = JSON.stringify(this.negativeAnswers)
        } else {
          form.response_type_negative_response = '[]'
        }

        if (this.responseType && this.responseType.value && this.addDescription && this.addDescription.value && this.addAttachments && this.addAttachments.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) {
          piincHttp.put('questions/' + this.selectedQuestion.slug, form).then(function(response) {
            self.$toastr('success', self.$t('maintenance.questions.update.success'))
            self.hideEditRRModal();
            self.loadQuestions();
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.responseType || (this.responseType && !this.responseType.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message')
          }
          if (!this.addDescription || (this.addDescription && !this.addDescription.value)) {
            this.error += this.$t('maintenance.questions.create.add_description_error_message')
          }
          if (!this.addAttachments || (this.addAttachments && !this.addAttachments.value)) {
            this.error += this.$t('maintenance.questions.create.add_attachments_error_message')
          }
          if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
            this.error += this.$t('maintenance.questions.create.selected_options_error_message')
          }
        }
      },
      loadQuestion() {
        let self = this;

        piincHttp.get('questions/' + this.selectedQuestion.slug).then(function(response) {
          self.selectedQuestion.media = response.data.media
          self.selectedQuestion.links = response.data.links
        }, function() {});
      },
      loadQuestions() {
        let self = this;

        piincHttp.get('questions', { params:
          {
            page: 1,
            per_page: 1,
            assessment: this.assessment.id,
            client: this.getClient.slug
          }
        }).then(function(response) {
          let total = response.data.total_count

          piincHttp.get('questions', { params:
            {
              page: 1,
              per_page: total,
              assessment: self.assessment.id,
              client: self.getClient.slug
            }
          }).then(function(response) {
            self.loading = false;
            self.tableItems = response.data.items;
            // Set number of total items
            self.totalRows = response.data.total_count;
          }, function() {});
        }, function() {});
      },
      loadContent() {
        let self = this;
        piincHttp.get('assessments/' + this.$route.params.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.assessment = response.data;
        }, function() {});
      },
    },
    created () {
      this.assessment = this.object
      if (this.getClient && this.getClient.slug) {

      }
      // Table items
      this.loadQuestions();
    }
  }
</script>
